import { OrgType } from 'src/@types/org';

export enum Features {
  Canvass = 'canvass',
  Call = 'call',
  Text = 'text',
  Poll = 'poll',
  CustomModel = 'custom_model',
  Campaigns = 'campaigns',
  Relational = 'relational',
  CanvassingQA = 'canvassing_qa',
  Crm = 'crm',
}

export const orgHasPermission = (
  org: OrgType | undefined,
  features: Features[],
  mode: 'any' | 'all' = 'any'
): boolean => {
  const featureAccessTable = {
    [Features.Canvass]: (org: OrgType) => org.can_canvass,
    [Features.Call]: (org: OrgType) => org.can_call,
    [Features.Text]: (org: OrgType) => org.can_text,
    [Features.Poll]: (org: OrgType) => org.can_poll,
    [Features.CustomModel]: (org: OrgType) => org.can_custom_model,
    [Features.Campaigns]: (org: OrgType) => org.can_access_campaigns,
    [Features.Relational]: (org: OrgType) => org.has_relational_enabled,
    [Features.CanvassingQA]: (org: OrgType) => org.can_access_canvassing_qa,
    [Features.Crm]: (org: OrgType) => org.can_access_crm,
  };

  if (!org) return false;

  if (features.length === 0) return true;

  if (mode === 'all') {
    return features.every((feature) => featureAccessTable[feature](org));
  }
  return features.some((feature) => featureAccessTable[feature](org));
};
